import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import EditVariantsForm from '../../../component/attributesComps/EditVariantsForm';

const EditVariants = () => {


  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Variants"  pagename="Edit Variants" buttonText="Save"/>
      <EditVariantsForm />
    </div>
  );
};

export default EditVariants;
